import { Injectable, EventEmitter } from '@angular/core';
import { ErrorResponse } from '../models/error.model';

@Injectable()
export class CommonApiErrorHandlerService {

  private _onError: EventEmitter<ErrorResponse> = new EventEmitter();
  private _onCustomError: EventEmitter<string> = new EventEmitter();

  constructor() {
  }

  public get onError(): EventEmitter<ErrorResponse> {
    return this._onError;
  }

  public get onCustomError(): EventEmitter<string> {
    return this._onCustomError;
  }

  emitError(errorResponse: ErrorResponse) {
    this._onError.emit(errorResponse);
  }

  emitCustomError(componentName: string) {
    this._onCustomError.emit(componentName);
  }

  handleError(resp: Response, skipErrorHandling = false): Promise<any> {

    switch (resp.status) {
      case 0:
        console.log('connection error');
        break;
      case 401:
        console.warn('Unauthorized error, processing');
        break;
      case 403:
        // TODO impl logic
        break;
      default:
        break;
    }

    const errorResponse = new ErrorResponse(resp.status, resp);
    if (!skipErrorHandling) {
      this.emitError(errorResponse);
      console.error('Generic server error: ' + JSON.stringify(resp));
    }

    return Promise.reject(errorResponse);
  }
}
